<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent fullscreen scrollable)
  v-card.neutral200
    v-card-text.pt-8.pb-0
      .d-flex.justify-center
        v-container.pa-8(fluid style="width:2000px")
          .text-2xl.font-semibold.mb-4.neutral700--text Select item from your recent purchases/lists
          v-row.height-adjustment(no-gutters :style="{ 'min-height': heightAdjustment }")
            v-col.mr-4(cols="8")
              v-card.rounded-lg(outlined height="100%")
                v-row(no-gutters)
                  v-col(cols="4")
                    .px-2.pt-4
                      .d-flex.justify-center
                        v-btn-toggle.round-xl.mb-2.mx-2(v-model="category" mandatory style="width: 100%" dense)
                          v-btn.flex-grow-1.white
                            .text-none.font-semibold.text-sm(:class="getToggleBtnClass(0)") Recent
                          v-btn.flex-grow-1.white
                            .text-none.font-semibold.text-sm(:class="getToggleBtnClass(1)") Lists
                      .d-flex.align-center
                        v-spacer
                        v-btn(@click="clickSearch" icon color="neutral500")
                          v-icon(size="20") $yzi-search-sm
                        v-text-field(v-if="inventoryLists.showSearchField" v-model="inventoryLists.searchText" @blur="blurSearch" @input="queryChanged" solo dense flat placeholder="Type to search..." hide-details clearable autofocus)
                        //- v-btn(icon)
                        //-   v-icon $yzi-filter-line
                    v-progress-linear(v-if="inventoryLists.isFetching" height="3" indeterminate)
                    template(v-for="(inventoryList, inventoryListIdx) in inventoryLists.data")
                      v-list.pa-0.hover-bg(:class="[{ 'selected-bg': isSelectedInventoryList(inventoryList) }]" dense)
                        v-divider
                        v-list-item.py-4(@click="handleSelectedInventoryList(inventoryList)")
                          div
                            .text-sm.font-semibold.mb-1 {{ getName(inventoryList) }}
                            .d-flex.align-center
                              .text-xs.mr-4 {{ categoryId === 'RECENT' ? 'Order date' : 'Created on' }}: {{ getDate(inventoryList) }}
                              .text-xs(v-if="categoryId === 'LISTS'") Items: {{ inventoryList.total_item }}
                          v-spacer
                          v-icon mdi-chevron-right
                    div.d-flex.justify-end(v-if="inventoryLists.totalCount > inventoryLists.pageSize")
                      yc-pagination-custom(v-model="inventoryLists.currentPage" :parentPageSize.sync="inventoryLists.pageSize" :count="inventoryLists.totalCount" attach menu-top @input="inventoryListsPageChanged")
                  v-divider(vertical :style="{ height: heightAdjustment }")
                  v-col.text-left(style="overflow: hidden; min-width: 0;")
                    .py-6.px-8(style="overflow-x: auto;")
                      .text-md.font-semibold {{ getName(inventoryLists.selected) }}
                      .text-sm Select your item of choice.
                      v-data-table.mt-4.pb-6(v-model="selected" :headers="headers" :items="inventories.data" item-key="id" :items-per-page="inventories.pageSize" :loading="inventories.isFetching" hide-default-footer loader-height="2" show-select :item-class="rowClass")
                        template(v-slot:header.data-table-select="{ props }")
                          yc-checkbox(:input-value="allSelected" :indeterminate="props.indeterminate" :disabled="inventories.data.length === 0" @change="handleSelectAll")
                        template(v-slot:item.data-table-select="{ item, select, isSelected }")
                          yc-checkbox(:input-value="isSelected" :disabled="item.disabled" @change="select($event)")
                        template(v-slot:item.available_qty="{ item }")
                          .d-flex.align-center.justify-space-between
                            span(:class="{ 'danger700--text': item.available_qty === 0 }") {{ item.available_qty }}
                            yz-tooltip
                              template(#tooltip)
                                div On hand: {{ item.detail.inventory_qty || 0 }}
                                div Reserved: {{ item.detail.reserved_qty || 0 }}
                                div Committed: {{ item.detail.committed_qty || 0 }}
                                div Incoming: {{ item.detail.preorder_qty || 0 }}
                              yz-icon(size="14" color="neutral500") $yzi-info-circle
                        template(v-slot:item.to_order_qty="{ item }")
                          span {{ item.to_order_qty }}
                      div.d-flex.justify-end(v-if="inventories.totalCount > inventories.pageSize")
                        yc-pagination-custom(v-model="inventories.currentPage" :parentPageSize.sync="inventories.pageSize" :count="inventories.totalCount" attach menu-top @input="inventoriesPageChanged")
            v-col
              v-card.border.rounded-lg(outlined height="100%")
                .pa-4
                  v-row(no-gutters)
                    v-col
                      .text-sm.font-semibold.mb-4 Selected item
                    v-spacer
                    v-col.d-flex.justify-end(v-if="selected.length > 0")
                      v-btn.button-xs.neutral700--text.underline.mr-1(text @click="handleRemoveAllItem") Remove all
                  template(v-if="selected.length === 0")
                    v-card.px-4.py-8.border-dashed(outlined)
                      .d-flex.flex-column.align-center.justify-center
                        v-icon.mb-6(size="30") $yzi-colors
                        .text-md.font-semibold.mb-1 No items selected
                        .text-sm.neutral500--text Any selected items from your list will show up here
                  div.overflow-selection(v-else)
                    div(v-for="(selectedItem, selectedItemIdx) in selected" :key="selectedItemIdx")
                      v-row.pa-2.align-center(no-gutters)
                        v-col(cols="2")
                          .text-sm {{ selectedItemIdx + 1 }}
                        v-col.mx-2
                          .text-sm {{ selectedItem.name }}
                        v-col.d-flex.justify-end(cols="2")
                          v-btn.button-xs.danger700--text.px-0.underline(text @click="handleRemoveItem(selectedItem)") Remove
                      v-divider(v-if="selectedItemIdx !== selected.length - 1")
    v-card-actions.white.pa-0
      .d-flex.flex-column(style="width:100%")
        v-divider
        .d-flex.justify-end.pa-4
          v-btn.button-md.neutral700--text.underline.mr-2(text @click="handleCloseDialog") Cancel
          v-btn.button-md.white--text(depressed color="neutral700" :disabled="!canProceed" @click="handleInsertInventory") Insert inventory
</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    open: {
      type: Boolean,
    },
    overrideCompanySlug: {
      type: String,
      default: null
    },
    selectedDocument: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      selected: [],
      inventories: {
        meta: {
          outOfStock: null,
          orderSoon: null,
        },
        data: [],
        isFetching: false,
        isError: false,
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
      },
      inventoryLists: {
        isFetching: false,
        isError: false,
        selected: null,
        data: [],
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        showSearchField: false,
        searchText: null,
      },
      headers: [
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Available', value: 'available_qty', sortable: true },
        { text: 'To Order', value: 'to_order_qty', sortable: true },
        { text: 'Last 7D', value: 'last7d' },
        { text: 'Last 14D', value: 'last14d' },
        { text: 'Last 30D', value: 'last30d' },
      ],
      category: 0
    }
  },
  async mounted () {
    await this.fetchInventoryList()
    if (this.inventoryLists.data.length > 0) {
      this.handleSelectedInventoryList(this.inventoryLists.data[0])
    }
  },
  watch: {
    async category () {
      this.inventoryLists.currentPage = 1
      this.inventories.currentPage = 1
      this.inventories.data = []
      await this.fetchInventoryList()
      if (this.inventoryLists.data.length > 0) {
        this.handleSelectedInventoryList(this.inventoryLists.data[0])
      }
    },
    'inventoryLists.selected': {
      handler () {
        this.inventories.currentPage = 1
        this.fetchInventories()
      },
    },
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    allSelected () {
      const selectableItems = this.inventories.data.filter(item => !item.disabled)
      if (selectableItems.length === 0) return false
      const productIds = selectableItems.map(item => item.id)
      return this.selected.filter(item => productIds.includes(item.id)).length === productIds.length
    },
    isStockTransfer () {
      return this.selectedDocument?.id === 'stock-transfer'
    },
    inventoriesParams () {
      const params = {
        page: this.inventories.currentPage,
        page_size: this.inventories.pageSize,
        status: 'published'
      }
      switch (this.categoryId) {
        case 'RECENT':
          params.purchase_invoice = this.inventoryLists.selected.id
          break

        case 'LISTS':
          params.inventorylist = this.inventoryLists.selected.id
          break
      
        default:
          break
      }

      return params
    },
    inventoryListsParams () {
      return {
        page: this.inventoryLists.currentPage,
        page_size: this.inventoryLists.pageSize,
        search: this.inventoryLists.searchText
      }
    },
    categoryId () {
      return this.category === 0 ? 'RECENT' : 'LISTS'
    },
    canProceed () {
      return this.selected.length > 0
    },
    endpoint () {
      switch (this.categoryId) {
        case 'RECENT':
          return `/purchases/${this.companySlugToUse}/invoices`

        case 'LISTS':
          return `/clinics/${this.companySlugToUse}/inventory_lists`

        default:
          return null
      }
    },
    heightAdjustment () {
      if (this.$vuetify.breakpoint.mdAndUp) return '75dvh'

      return '60dvh'
    },
    companySlugToUse() {
      return this.overrideCompanySlug || this.company.slug
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    inventoriesPageChanged () {
      this.fetchInventories()
    },
    inventoryListsPageChanged () {
      this.fetchInventoryList()
    },
    async fetchInventoryList () {
      try {
        this.inventoryLists.isFetching = true
        const { data } = await this.axios.get(this.endpoint, { params: this.inventoryListsParams })
        this.inventoryLists.totalCount = data.count
        this.inventoryLists.data = data.results
      } catch (error) {
        this.inventoryLists.isError = true
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.inventoryLists.isFetching = false
      }
    },
    async fetchInventories () {
      try {
        this.inventories.isFetching = true
        const endpoint = `/clinics/${this.companySlugToUse}/inventories`
        const { data } = await this.axios.get(endpoint, { params: this.inventoriesParams })
        this.inventories.totalCount = data.count
        this.inventories.data = data.results.map(result => this.sanitizeData(result))
      } catch (error) {
        this.inventories.isError = true
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.inventories.isFetching = false
      }
    },
    handleSelectAll (value) {
      if (value) {
        const selectable = this.inventories.data.filter(item => !item.disabled)
        this.selected = [...this.selected, ...selectable]
      } else {
        const productsId = this.inventories.data.map(item => item.id)
        this.selected = this.selected.filter(item => !productsId.includes(item.id))
      }
    },
    hasStock (item) {
      if (!item.detail.inventory_enabled) return true
      return item.available_qty > 0
    },
    rowClass (item) {
      return item.disabled ? 'row-disabled-bg' : ''
    },
    handleRemoveItem (item) {
      this.selected = this.selected.filter(selectedItem => selectedItem.id !== item.id)
    },
    handleRemoveAllItem () {
      this.selected = []
    },
    sanitizeData (data) {
      const row = {
        detail: data,
        id: data.id,
        name: data.name,
        available_qty: data.available_qty,
        to_order_qty: data.to_order_qty,
        last7d: data.usage['7_days'],
        last14d: data.usage['14_days'],
        last30d: data.usage['30_days'],
      }
      row.disabled = this.isStockTransfer && !this.hasStock(row)
      return row
    },
    handleCloseDialog () {
      this.$emit('closed')
      this.showDialog = false
    },
    getToggleBtnClass(index) {
      return this.category === index ? '' : 'neutral500--text'
    },
    clickSearch () {
      if (this.inventoryLists.showSearchField) {
        if (!this.inventoryLists.searchText || this.inventoryLists.searchText.length === 0) {
          this.inventoryLists.showSearchField = false
        }
      } else {
        this.inventoryLists.showSearchField = true
      }
    },
    blurSearch () {
      if (!this.inventoryLists.searchText || this.inventoryLists.searchText.length === 0) {
        this.inventoryLists.showSearchField = false
      }
    },
    queryChanged: debounce(function () {
      this.inventoryLists.currentPage = 1
      this.fetchInventoryList()
    }, 750),
    handleSelectedInventoryList (inventoryList) {
      this.$set(this.inventoryLists, 'selected', inventoryList)
    },
    isSelectedInventoryList (item) {
      return this.inventoryLists.selected?.id === item.id
    },
    handleInsertInventory () {
      this.$emit('added', this.selected)
      this.handleCloseDialog()
    },
    getDate (item) {
      let date
      switch (this.categoryId) {
        case 'RECENT':
          date = item.record_date
          break
        
        case 'LISTS':
          date = item.created
          break

        default:
          return null
      }

      if (!date) return null

      return this.$options.filters.convertToDateOnly(date)
    },
    getName (item) {
      let name
      switch (this.categoryId) {
        case 'RECENT':
          name = item?.supplier?.value
          return name ?? null
        
        case 'LISTS':
          name = item.name
          return name ?? null

        default:
          return null
      }
    },
  },
}
</script>
  
<style scoped>
.overflow-selection {
  max-height: 600px;
  overflow-y: auto;
}
::v-deep tr.row-disabled-bg,
::v-deep tr.row-disabled-bg:hover,
::v-deep tr.row-disabled-bg.v-data-table__selected {
  background-color: #f5f5f5 !important;
}
::v-deep tr.row-disabled-bg td {
  color: #9ca3af;
}
</style>
